
if ($('.cookie-banner').length > 0) {

    $('.cookie-banner .accept').on('click', acceptCookies);

    var getUrl = window.location;
    var baseUrl = getUrl.protocol + "//" + getUrl.host + "/" + getUrl.pathname.split('/')[0];

    function acceptCookies(e) {
        $.post(baseUrl + 'api/cookieapi/acceptcookie', () => {
            $('.cookie-banner').fadeOut(200);
        });
    }

}
